import { TaxLinesBus } from './TaxLinesBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { CommonValues } from '../static/CommonValues';

export class TaxCodeBus extends BaseBus  {
    constructor(data: TaxCodeBus = null) {
        super(data);

    }
    CID() {
        return this.taxCodeId;
    }
    taxCodeId: any;
    personId: any;
    companyId: any;
    isActive: boolean;
    isRetailTax: boolean;
    isAvalara: boolean;
    taxCode: string;
    taxDesc: string;
    taxRate: number;
    taxLines: TaxLinesBus[];

    get hasTaxLines(): boolean {
        return CommonFunctions.hasArrayElementValue(this.taxLines);
    }
    set hasTaxLines(value: boolean) {

    }
    get hasTax(): boolean {
        return CommonFunctions.hasNumberValue(this.taxRate);
    }
    set hasTax(value: boolean) {

    }
    public IsTaxable(billingTypeId: any, isPart: boolean): boolean {
        var isTaxable: boolean = false;
        if (this.hasTaxLines) { // CommonFunctions.hasArrayElementValue(this.taxLines)) {
            if (isPart || (billingTypeId == CommonValues.BillingType_NonInventoryPart && this.taxLines[0].isTaxMaterial)) {
                isTaxable = true;
            }
            else if (billingTypeId == CommonValues.BillingType_Labor && this.taxLines[0].isTaxLabor) {
                isTaxable = true;
            }
            else if (billingTypeId == CommonValues.BillingType_Other && this.taxLines[0].isTaxOther) {
                isTaxable = true;
            }
        }
        return isTaxable;
    }
}
